<template>
  <div class="appeals-tb">
    <a
        class="appeals-tb__link"
        :class="{'appeals-tb__link--active': active === null}"
        href="#"
        @click.prevent="clickHandle(null)"
    >
      Все: {{ allAmount }}
    </a>
    <a
        class="appeals-tb__link"
        :class="{'appeals-tb__link--active': active === true}"
        href="#"
        @click.prevent="clickHandle(true)"
    >
      Активные: {{ activeAmount }}
    </a>
    <a
        class="appeals-tb__link"
        :class="{'appeals-tb__link--active': active === false}"
        href="#"
        @click.prevent="clickHandle(false)"
    >
      Завершены: {{ finishedAmount }}
      <div v-if="completedDot" class="completed-dot"></div>
    </a>
  </div>
</template>

<script>
export default {
  name: "AppealsTabBar",
  props: {
    value: {
      type: Boolean,
      default: null
    },
    allAmount: {
      type: Number,
      default: 0
    },
    activeAmount: {
      type: Number,
      default: 0
    },
    finishedAmount: {
      type: Number,
      default: 0
    },
    completedDot: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      active: this.value
    }
  },
  methods: {
    clickHandle(val) {
      this.active = val;
      this.$emit('input', val)
    }
  }
}
</script>

<style lang="scss" scoped>
@import "@/assets/scss/md/_variables.scss";
.appeals-tb {
  width: 100%;
  max-width: 420px;
  border: 1px solid #eee;
  border-radius: 2px;
  display: inline-flex;
  @media (max-width: 768px) {
    // border: unset;
    border-radius: 6px;
  }
  &__link {
    padding: 8.5px 15px;
    flex-grow: 1;
    color: var(--md-theme-tab-bar-color) !important;
    text-align: center;
    white-space: nowrap;
    position: relative;
    @media (max-width: 768px) {
      padding: 2px 7px;
      font-size: 12px;
      &:not(:last-child) {
        border-right: 1px solid #ffffff;
      }
    }
  }
  &__link:first-child {
    border-bottom-left-radius: 2px;
    border-top-left-radius: 2px;
  }
  &__link:last-child {
    border-bottom-right-radius: 2px;
    border-top-right-radius: 2px;
  }
  &__link--active {
    color: #ffffff !important;
    background-color: var(--md-theme-tab-bar-color) !important;
  }
  .completed-dot {
    position: absolute;
    right: 13px;
    top: 17px;
    width: 7px;
    height: 7px;
    background-color: red;
    border-radius: 50%;
  }
}
</style>
